import { type PromoCodeList, type PromoCodeWithIsoCodeAndDocumentId } from "@repo/common";

export const formatPromoCodeType = (type: PromoCodeWithIsoCodeAndDocumentId["type"]): string => {
  if (type === "freeMonths") {
    return "Kostenlose Monate";
  }

  return type;
};

export const isoDateToLocaleDateString = (isoDate: string): string => {
  return new Date(isoDate).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const isPromoCodeExpired = (expiresOnIsoDate: string): boolean => {
  return new Date(expiresOnIsoDate) < new Date();
};

const cellToString = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  return JSON.stringify(value);
};

const escapeCsv = (value: unknown): string => {
  const stringValue = cellToString(value);
  const needsQuotes = /[",\n;]/.test(stringValue);
  const escaped = stringValue.replace(/"/g, '""');
  return needsQuotes ? `"${escaped}"` : escaped;
};

export const downloadPromoCodesCsv = (codes: PromoCodeList["promoCodes"]): void => {
  if (!codes.length) return;

  const headers = ["Code", "Typ", "Monate", "Erstellt am (ISO)", "Ablaufdatum (ISO)", "Abgelaufen", "Eingelöst"];

  const rows = codes.map((promoCode) => [
    promoCode.code,
    formatPromoCodeType(promoCode.type),
    promoCode.codeValue,
    promoCode.createdOnIsoDate,
    promoCode.expiresOnIsoDate,
    String(isPromoCodeExpired(promoCode.expiresOnIsoDate)),
    String(Boolean(promoCode.usedOnIsoDate)),
  ]);

  const csv = [headers, ...rows].map((row) => row.map(escapeCsv).join(",")).join("\n");
  const bom = "\uFEFF";
  const blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");

  link.href = url;
  link.download = `promo-codes-${timestamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
